import { Component, computed, input } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { openLinkInNewTab } from "blu-utilities";
import { QuicklinkModule } from "ngx-quicklink";
import { AddClassModifierDirective } from "src/app/core/directives/add-class-modifier.directive";
import { NavItemOptions } from "src/models/nav";
import { AppService } from "src/services/app.service";

@Component({
  selector: "app-nav-item",
  templateUrl: "./nav-item.component.html",
  styleUrl: "./nav-item.component.scss",
  imports: [
    RouterLinkActive,
    AddClassModifierDirective,
    RouterLink,
    QuicklinkModule,
  ],
})
export class NavItemComponent {
  isSideBarCollapsed = this.appService.isSideBarCollapsed;
  readonly navItem = input.required<NavItemOptions>();

  readonly getIconUrl = computed(() =>
    this.navItem() ? `assets/icons/sidebar/${this.navItem().icon}.svg` : "",
  );

  readonly getActiveIconUrl = computed(() =>
    this.navItem()
      ? `assets/icons/sidebar/white/${this.navItem().icon}.svg`
      : "",
  );

  constructor(private appService: AppService) {}

  redirectTo(event: MouseEvent) {
    if (event.button === 1 && this.navItem().link) {
      openLinkInNewTab(this.navItem().link);
    }
  }

  setIsSideNavBarVisible(value: boolean) {
    this.appService.setIsSideNavBarVisible(value);
  }
}
